import React, { useCallback } from 'react';
import {
  MainDiv,
  NewProjectSection,
  TitleSection,
  Title,
  Subtitle,
  OptionSection,
  OptionCard,
  OptionCardTitle,
  Icon,
  DescriptionSection,
  OptionCardDescription,
  OuterDiv
} from './style';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes/urls';
import { useMobileDevice } from '../../../global/useMobile';
import ResponsiveHeader from '../../../component/responsiveHeader/header';

const OptionCardData = [
  {
    title: 'Blank Project',
    description: 'Start from scratch',
    icon: 'plus-icon'
  },
  {
    title: 'Use a template',
    description: 'Coming soon',
    icon: 'template-icon'
  },
  {
    title: 'Import Spreadsheet',
    description: 'Coming soon',
    icon: 'spreadsheet-icon'
  }
];

function CreateProjectStep1() {
  const history = useHistory();
  const isMobile = useMobileDevice();

  const onClickOptionCard = useCallback(
    (title: string) => {
      if (title === 'Blank Project') {
        history.push(ROUTES.CREATE_PROJECT_STEP2);
      }
    },
    [history]
  );

  const renderOptionCard = useCallback(() => {
    return OptionCardData.map((item) => {
      return (
        <OptionCard
          onClick={() => onClickOptionCard(item.title)}
          className={item.title === 'Blank Project' ? 'active' : ''}
          comingSoon={item.description === 'Coming soon'}>
          <Icon className={item.title === 'Blank Project' ? 'blank-project' : ''}>
            <SVGIcon name={item.icon} width='36' height='36' viewBox='0 0 18 18' fill='var(--text-secondary)' />
          </Icon>
          <DescriptionSection comingSoon={item.description === 'Coming soon'}>
            <OptionCardTitle>{item.title}</OptionCardTitle>
            <OptionCardDescription comingSoon={item.description === 'Coming soon'}>
              {item.description}
            </OptionCardDescription>
          </DescriptionSection>
        </OptionCard>
      );
    });
  }, [onClickOptionCard]);

  const renderCloseIcon = useCallback(() => {
    return (
      <Icon className='close-Icon' onClick={() => history.goBack()}>
        <SVGIcon name='new-close-icon' width='20' height='20' viewBox='0 0 18 18' fill='var(--text-secondary)' />
      </Icon>
    );
  }, [history]);

  return (
    <>
      <OuterDiv>
        {isMobile ? (
          <ResponsiveHeader Title='Create New Project' noMargin={true} leftElement={renderCloseIcon()} />
        ) : (
          renderCloseIcon()
        )}
        <MainDiv>
          <NewProjectSection>
            <TitleSection>
              {!isMobile && <Title>Create New Project</Title>}
              <Subtitle>How would you like to start?</Subtitle>
            </TitleSection>
            <OptionSection>{renderOptionCard()}</OptionSection>
          </NewProjectSection>
        </MainDiv>
      </OuterDiv>
    </>
  );
}

export default CreateProjectStep1;
